<template>
  <div class="sidebar-content sidebar-content--collar">
    <h1 class="sidebar-title">Collar Style</h1>
    <h3 v-if="!collarEditMode" class="sidebar-subtitle">Pick a Collar style</h3>
    <h3 v-if="collarEditMode" class="sidebar-subtitle">Pick Collar Inside Color</h3>
    <ul v-if="!collarEditMode" class="collars-wrap">
      <li class="collar-item" v-for="(collar, index) in collarValues" :key="index"
          @click="onChange(collar)" :class="{active: collar === activeCollarType}">
        <component class="collar-canvas"
                   :is="collar"
                   :collar="collar"
        />
        <div class="collar-sub-image-wrap">
          <img class="collar-sub-image"
               :class="collar" :src="require(`@/assets/images/${collar}.png`)">
        </div>
      </li>
    </ul>
    <CollarModeDisplay
      v-if="collarEditMode"
      :editingCollar="editingCollar"
      :collarEditMode="collarEditMode"
      @collarEditModeOff="collarEditModeOff"
    />
  </div>
</template>

<script>
import { COLLARS } from '@/common/constants';
import classic from '@/components/jacket/collars/Classic.vue';
import hoodie from '@/components/jacket/collars/Hoodie.vue';
import zipperHood from '@/components/jacket/collars/ZipperHood.vue';
import CollarModeDisplay from '@/components/jacket/collars/CollarModeDisplay.vue';

export default {
  name: 'CollarSidebar',
  components: {
    classic,
    hoodie,
    zipperHood,
    CollarModeDisplay
  },
  data () {
    return {
      COLLARS,
      collarEditMode: false,
      editingCollar: {},
    };
  },

  computed: {
    activeCollarType () {
      return this.$store.getters['design/getCollarType'];
    },

    collarValues () {
      return Object.values(COLLARS);
    },

    isHooded () {
      return this.$store.getters['design/getIsHooded'];
    },

    totalPrice () {
      return this.$store.getters['finalizeOrder/getTotalPrice'];
    },

    prices () {
      return this.$store.getters['finalizeOrder/getPrices'];
    },
  },

  methods: {
    click () {
      console.log('click');
    },

    onChange (collar) {
      if (collar !== COLLARS.CLASSIC) {
        this.collarEditMode = true;
        this.editingCollar = collar;
      }

      this.$store.dispatch('design/setCollarType', collar);

      if (collar === COLLARS.ZIPPER_HOOD && this.isHooded === false) {
        this.$store.commit('design/setIsHooded', true);
        this.$store.dispatch('finalizeOrder/calculateTotalPrice');
      }

      if ((collar === COLLARS.CLASSIC || collar === COLLARS.HOODIE) && this.isHooded === true) {
        this.$store.commit('design/setIsHooded', false);
        this.$store.dispatch('finalizeOrder/calculateTotalPrice');
      }
    },
    collarEditModeOff () {
      this.collarEditMode = false;
      this.editingCollar = null;
    },
  }
};
</script>

<style scoped>
  .collars-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .collar-item {
    height: 145px;
    cursor: pointer;
    position: relative;
    &:hover,
    &.active {
      background: rgba(216, 216, 216, 0.2);
    }
  }

  .collar-canvas {
    height: 145px;
    position: relative;
    z-index: 10;
  }

  .collar-sub-image-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .collar-sub-image {
    position: absolute;
    left: 50%;
    top: 41%;
    transform: translate(-50%, -50%);
    width: 79%;
  }
  .collar-title {
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 500;
  }

  .classic {
    top: 44%;
    width: 41%;
  }

</style>
